<template>
    <div class="prebillContainer">
        <el-divider></el-divider>
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-info">
                        <div class="box-header with-border">
                            <h3 class="box-title">
                                Factura
                            </h3>
                        </div>
                        <div class="box-body">
                            <el-form :model="document" label-position='right' label-width="200px" class="form-container" :disabled="true">
                                <div v-if="document.code">
                                    <el-divider v-if="document.code">Documentación Adjunta</el-divider>
                                    <el-form-item size="small" label="Código de Documentación" class="form-select">
                                        <el-input v-model="document.code" placeholder="Código de Documentación">
                                        <!-- <el-option
                                            v-for="item in hesMigo"
                                            :key="item.idHes"
                                            :label="item.number"
                                            :value="item.idHes">
                                        </el-option> -->
                                    </el-input>
                                    </el-form-item>
                                    <div>
                                        <el-form-item label="Descripción" class="form-input" size="small">
                                            <el-input disabled v-model="document.description"></el-input>
                                        </el-form-item>
                                        <el-form-item label="Tipo de Documentación" class="form-input" size="small">
                                            <el-input disabled v-model="document.tipo"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <el-divider> Datos del Documento </el-divider>
                                <el-form-item size="small" label="Tipo de operación" class="form-select" >
                                    <el-select v-model="document.documenttype" placeholder="Tipo de operación">
                                        <el-option
                                            v-for="item in documentType"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Código de AFIP" class="form-input" size="small" >
                                    <el-input v-model="document.codigoAFIP"></el-input>
                                </el-form-item>
                                <el-form-item label="Letra" class="form-input" size="small" >
                                    <el-input v-model="document.letra"></el-input>
                                </el-form-item>
                                <el-form-item label="Número" class="form-input" size="small" >
                                    <el-input v-model="document.numero"></el-input>
                                </el-form-item>
                                <el-form-item label="Proveedor" class="form-input" size="small" >
                                    <el-select filterable v-model="document.proveedor">
                                        <el-option
                                            v-for="item in providers"
                                            :key="item.idCompany"
                                            :label="item.company"
                                            :value="item.idCompany"
                                            >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-divider>Datos CAE</el-divider>
                                <el-form-item label="Fecha de Vencimiento" class="form-input" size="small" >
                                    <el-date-picker
                                        class="form-date"
                                        v-model="document.fechaVencimiento"
                                        type="date"
                                        placeholder="Selecciona fecha de vencimiento"
                                        :default-value="new Date()"
                                    />
                                </el-form-item>
                                <el-form-item label="Nº" class="form-input" size="small" >
                                    <el-input v-model="document.NroCAE"></el-input>
                                </el-form-item>
                                <el-form-item size="small" label="PDF" class="form-upload" >
                                    <pdf-file
                                    v-bind:pdfFilePath.sync="document.pdfDoc"
                                    :habModificaPdf="false"
                                    id="documento"
                                    class="form-pdf"
                                />
                                </el-form-item>
                                <el-divider v-if="loadOperationType === true" content-position="left">Datos de Referencia</el-divider>
                                <el-form-item v-if="loadOperationType === true" size="small" label="Tipo de transacción" class="form-select">
                                    <el-select v-model="document.ocType" placeholder="Tipo de transacción">
                                    <el-option
                                        v-for="item in acceptanceType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                </el-form-item>
                                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'" :key="index">
                                    <el-row>
                                        <el-col :span="24">
                                            <p class="input-text">Número de operación</p>
                                        </el-col>
                                        <el-col :span="12" class="input-view1">
                                            <el-input v-model="document.ocNumber" placeholder="Numero de HES"></el-input>
                                        </el-col>
                                        <el-col :span="12" class="input-view2">
                                            <el-button style="margin-left: 35px;" type="warning" @click="addOcNumber">+</el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'" v-for="(ocNumber, index) in document.ocNumbers" :key="index">
                                    <el-row>
                                        <el-col :span="12" class="input-view1">
                                            <el-input v-model="ocNumber.value" placeholder="Numero de HES"></el-input>
                                        </el-col>
                                        <el-col :span="12" class="input-view2">
                                            <el-button style="margin-left: 35px;" type="warning" @click="deleteOcNumber(index)">-</el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-form-item size="small" class="form-input" v-if="document.ocType === '2'">
                                    <el-row>
                                        <el-col :span="24">
                                            <p class="input-text">Número de operación</p>
                                        </el-col>
                                        <el-col :span="12" class="input-view1">
                                            <el-input placeholder="Numero de MIGO" v-model="document.migoNumber"></el-input>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-divider>Importes</el-divider>
                                <el-form-item label="Importe Total" class="form-input" size="small" >
                                    <el-input v-model="document.importeTotal"></el-input>
                                </el-form-item>
                                <el-form-item label="Importe Impuesto" class="form-input" size="small" >
                                    <el-input v-model="document.importeImpuesto"></el-input>
                                </el-form-item>
                                <el-form-item label="Porcentaje Impuesto" class="form-input" size="small" >
                                    <el-input v-model="document.porcentajeImpuesto"></el-input>
                                </el-form-item>
                                <el-form-item label="Moneda" class="form-input" size="small" >
                                    <el-input v-model="document.moneda"></el-input>
                                </el-form-item>
                                <el-form-item label="Tipo de Cambio" class="form-input" size="small" >
                                    <el-input v-model="document.tipoDeCambio"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
  import api from '../../api'
  import PdfFile from '../PdfFile.vue'
  import UploadOrder from './UploadOrder.vue'
  export default {
    name: 'Prebill',
    components: {
      'pdf-file': PdfFile,
      'upload-order': UploadOrder
    },
    props: {
      loadOperationType: {
        type: Boolean
      }
    },
    data () {
      return {
        isLoading: false,
        providers: [],
        document: {
          documenttype: '',
          ocType: '',
          ocNumbers: [],
          pdfDoc: '',
          migoNumber: '',
          codigoAFIP: '',
          letra: '',
          numero: '',
          proveedor: '',
          fechaVencimiento: '',
          NroCAE: '',
          importeTotal: '',
          importeImpuesto: '',
          porcentajeImpuesto: '',
          moneda: '',
          tipoDeCambio: ''
        },
        documentType: [{value: '1', label: 'Factura'}, {value: '2', label: 'Nota de crédito'}, {value: '3', label: 'Nota de débito'}],
        acceptanceType: [{value: '1', label: 'HES'}, {value: '2', label: 'MIGO'}],
        habModificaPdf: true
      }
    },
    methods: {
      getBill () {
        api.request('GET', 'api/getBuyOrderDocumentDetails/' + this.$route.params.id)
        .then((response) => {
          this.document = response.data
          console.log('document', this.document)
        })
        .catch((error) => {
          this.$message.error('Error al obtener la factura')
          console.log(error)
        })
      },
      getProviders () {
        this.$store.commit('START_LOADING')
        api.request('GET', 'api/listCompany')
        .then(response => {
          this.providers = response.data
          console.log('providers', this.providers)
          this.$store.commit('STOP_LOADING')
        })
        .catch(error => {
          console.log(error)
          this.$store.commit('STOP_LOADING')
        })
      }
    },
    beforeMount () {
      this.getProviders()
      this.getBill()
    }
  }
</script>
<style>
.prebillContainer{
    display: flex;
    flex-direction: column;
}
.prebill{
    display: flex;
    justify-content: center;
    align-items: center;
}

.box{
    max-width: 90vw;
    margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// Bill.vue?c0810a6a